import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/'
import 'bulma/css/bulma.min.css'
import 'bulma-pageloader/'
import * as firebase from './firebaseUtil';
import ImageUploader from 'vue-image-upload-resize';
// import {firebaseConfig} from './config'
import dotenv from 'dotenv';
dotenv.config();

Vue.use(ImageUploader);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App),
    created () {
        firebase.auth().onAuthStateChanged(async user => {
            await store.dispatch('setUser', user);
        })
    }
}).$mount('#app');
